/*
 *
 * QrCodePopup
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 16-Jun-2025
 */

import QrCodePopup from './QrCodePopupContainer'

export default QrCodePopup
